import type { Point2d } from "../../../../common/geometry/Geom2d";

import { Color } from "../../../../utils/sys/Color";
import { Dictionary } from "../../../../utils/sys/Dictionary";
import TabletopElement from "../element/TabletopElement";
import TabletopViewport from "../TabletopViewport";

export default abstract class TabletopGrid extends TabletopElement {
    public static readonly highlightColorNeutral: Color = "#eeeeee88";
    public static readonly hightlightColorValid: Color = "#10ef6188";
    public static readonly hightlightColorInvalid: Color = "#ef102588";

    protected _unitLength: number;
    private _cellHighlights: Dictionary<number, Dictionary<number, Color>> =
        new Dictionary();

    public constructor(unitLength: number = 36) {
        super();
        this._unitLength = unitLength;
    }

    public abstract getCellCoordinatesFromUniversePoint(
        point: Point2d,
    ): Point2d;

    public abstract getCellCoordinatesFromViewportPoint(
        point: Point2d,
        viewport: TabletopViewport,
    ): Point2d;

    public abstract getUniversePointFromCellCoordinates(
        cellCoord: Point2d,
    ): Point2d;

    public abstract getViewportPointFromCellCoordinates(
        cellCoord: Point2d,
        viewport: TabletopViewport,
    ): Point2d;

    public abstract snapUniversePointToGrid(point: Point2d): Point2d;

    public abstract snapViewportPointToGrid(
        point: Point2d,
        viewport: TabletopViewport,
    ): Point2d;

    public get cellHighlights() {
        return this._cellHighlights;
    }

    public setCellHighlight(x: number, y: number, color: Color | null) {
        if (color == null) {
            this._cellHighlights.get(x)?.remove(y);
        } else {
            if (!this._cellHighlights.hasKey(x)) {
                this._cellHighlights.set(x, new Dictionary<number, Color>());
            }

            this._cellHighlights.get(x)?.set(y, color);
        }
    }
}
